import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, ToastController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { EszkozService } from '../eszkoz.service';
import { NaploService } from '../../naplo/naplo.service';
import { KeretService } from '../../keret.service';
import { SzerkZar, SzerkZarService } from '../../components/szerk-zar/szerk-zar.service';

/*  TÁRGYI ESZKÖZÖK – a Tárgyi eszköz (ESZKOZ) modul képernyője (/eszkoz/eszkozok, /eszkoz/ecs).
 *  A NAPLO ügyfeleivel dolgozik; kettős könyvvitelnél az écs és a kivezetés a főkönyvbe is megy,
 *  más ügyfélnél csak a nyilvántartásba.
 *
 *  Nyilvántartás + havi értékcsökkenés. Eszközönként két écs fut: a SZÁMVITELI (a hasznos
 *  élettartam szerinti kulcs – ez könyvelődik) és a TÁRSASÁGI ADÓ szerinti (Tao tv. 2. sz.
 *  melléklet – a különbözet adóalap-korrekció). A havi écs napra arányos az aktiválás és a
 *  kivezetés hónapjában; a kis értékű eszköz (Szt. 80. § (2)) egy összegben is elszámolható.
 *  A feladás egy vegyes bizonylat (T écs-költség / K halmozott écs), és csak visszafelé vonható
 *  vissza, mert a halmozott érték hónapról hónapra épül. Számolás: backend/kettos-eszkoz.js. */
@Component({
  selector: 'app-eszkoz-eszkozok',
  templateUrl: './eszkozok.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', './eszkozok.component.scss'],
})
export class EszkozokComponent implements OnInit, OnDestroy {
  ful: 'lista' | 'ecs' = 'lista';
  csoportok: any[] = [];
  kivezetesJogcimek: any[] = [];
  eszkozok: any[] = [];
  osszesen: any = {};
  kereso = '';
  kivezetettek = false;
  kisErtekuHatar = 200000;
  betolt = false;

  szerk: any = null;              // a szerkesztett eszköz
  karton: any = null;             // a szerkesztett eszköz kartonja
  kivezetes: any = null;          // { datum, jogcim, megjegyzes }
  zar: SzerkZar | null = null;    // a szerkesztett eszköz szerkesztési zárja
  private zarKor = 0;
  private vege = false;

  ho = new Date().getMonth() + 1;
  honapok = Array.from({ length: 12 }, (_, i) => i + 1);
  /*  Feladás gyakorisága (ügyfelenként): havi vagy negyedéves. Negyedévesnél is havonta számol
   *  (napi arányosítás), csak egy bizonylat készül a negyedév végével. */
  negyedev = Math.ceil((new Date().getMonth() + 1) / 3);
  negyedevek = [1, 2, 3, 4];
  get negyedeves(): boolean { return this.rend?.ecs_gyakorisag === 'negyedeves'; }
  private idoszakQuery(): string { return this.negyedeves ? `negyedev=${this.negyedev}` : `ho=${this.ho}`; }
  get idoszakNev(): string { return this.negyedeves ? `${this.aktiv.ev}. ${this.negyedev}. negyedév` : `${this.aktiv.ev}. ${this.honapNev(this.ho)}`; }
  async gyakorisagValt(v: string) {
    try {
      await this.eszkoz.putAbs(this.api(`/beallitas/${this.u}`), { ecs_gyakorisag: v });
      this.rend = { ...this.rend, ecs_gyakorisag: v };
      await this.ecsBetolt();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }

  /*  Szállító (a könyvelés partnertörzséből) és főkönyvi számok (a kettős számlatükörből) –
   *  a Könyvelés választóival azonos módon: beírható, vagy a ▸ gombbal kereshető listából. */
  partnerek: any[] = [];
  szamlak: any[] = [];
  private torzsUgyfel: string | null = null;
  private async torzsBetolt() {
    if (!this.u || this.torzsUgyfel === this.u) return;
    this.torzsUgyfel = this.u;
    try { this.partnerek = await this.eszkoz.getAbs(this.api(`/partnerek/${this.u}`)); } catch { this.partnerek = []; }
    try { this.szamlak = this.kettos ? await this.eszkoz.getAbs(this.api(`/szamlak/${this.u}`)) : []; } catch { this.szamlak = []; }
  }
  partnerNevValt() {
    const n = String(this.szerk?.partner_nev || '').trim().toLowerCase();
    const p = this.partnerek.find((x) => String(x.nev).toLowerCase() === n);
    this.szerk.partner_id = p ? p.id : null;
  }
  szamlaNev(sz: string): string { return this.szamlak.find((x) => x.szamlaszam === sz)?.nev || ''; }
  valaszto: { fajta: 'partner' | 'szamla'; mezo: string; cim: string } | null = null;
  valasztoKereso = '';
  valasztoNyit(fajta: 'partner' | 'szamla', mezo: string) {
    this.valasztoKereso = '';
    this.valaszto = { fajta, mezo, cim: fajta === 'partner' ? 'Szállító – partnertörzs' : 'Főkönyvi szám – számlatükör' };
  }
  get valasztoLista(): any[] {
    const k = this.valasztoKereso.trim().toLowerCase();
    const l = this.valaszto?.fajta === 'partner'
      ? this.partnerek.map((p) => ({ kod: String(p.kod), nev: p.nev, obj: p }))
      : this.szamlak.map((x) => ({ kod: x.szamlaszam, nev: x.nev, gyujto: !!Number(x.gyujto), obj: x }));
    return (k ? l.filter((x) => x.kod.toLowerCase().includes(k) || String(x.nev).toLowerCase().includes(k)) : l).slice(0, 300);
  }
  valasztoValaszt(x: any) {
    const v = this.valaszto; this.valaszto = null;
    if (!v || !this.szerk) return;
    if (v.fajta === 'partner') { this.szerk.partner_id = x.obj.id; this.szerk.partner_nev = x.obj.nev; }
    else if (!x.gyujto) this.szerk[v.mezo] = x.kod;
  }

  /*  A KÖNYVELT BIZONYLAT MEGNYITÁSA – a szállítói számla és a könyvelési sor a Könyvelésben. Az
   *  alrendszert is átváltjuk, és előtte a Könyvelés aktív ügyfelét erre állítjuk, hogy a könyvelő
   *  ablak már ezzel nyíljon (ne a korábbival). */
  async bizonylatNyit() {
    try {
      const r: any = await this.eszkoz.getAbs(this.api(`/eszkoz/${this.szerk.id}/bizonylat`));
      if (!r?.tetel) return this.hiba(this.szerk.szamlaszam ? `A(z) ${this.szerk.szamlaszam} számla nincs lekönyvelve ennél az ügyfélnél.` : 'Az eszközhöz nincs bizonylat – add meg a számlaszámot.');
      await this.naplo.init();
      let u: any = null;
      try { u = ((await this.naplo.get<any[]>('/ugyfelek/' + this.aktiv.intezmeny)) || []).find((x) => x.id === this.u); } catch { /* az eszköz-adat is elég */ }
      await this.naplo.setAktiv({ ugyfelId: this.u, ugyfelNev: u?.nev || this.aktiv.ugyfelNev, konyveles_mod: u?.konyveles_mod || this.aktiv.konyveles_mod,
        tipus: u?.tipus || 'ceg', bank_naplo: !!u?.bank_naplo, ev: Number(r.tetel.ev) || this.aktiv.ev });
      const cel = r.mod === 'kettos' ? `/naplo/kettos?nezet=kontir&tetel=${r.tetel.id}` : `/naplo/konyveles?tetel=${r.tetel.id}`;
      const k = this.keret.a;
      const mod = (k?.modok() || []).find((m) => m.name === 'NAPLO');
      this.bezar();
      if (k && mod) k.modValt(mod, cel); else this.router.navigateByUrl(cel);
    } catch (e: any) { this.hiba(e?.status === 403 ? 'Nincs jogosultságod a Könyveléshez.' : (e?.error?.error || 'Nem sikerült megnyitni a bizonylatot.')); }
  }
  ecs: any = null;
  feladasFut = false;

  kettos = false;                  // kettős könyvvitel: a feladás a főkönyvbe is megy
  /*  Az ügyfél adózási rendje (backend: adozasRend): kettos | szja | atalany | kata | egyszeres.
   *  konyvel: hová megy a feladás – 'fokonyv' (vegyes napló), 'naplo' (naplófőkönyv 6. oszlop), null (sehová). */
  rend: any = { adozas_rend: 'egyszeres', konyvel: 'naplo', afa_alany: true };
  get evRend(): boolean { return ['szja', 'atalany', 'kata'].includes(this.rend?.adozas_rend); }
  private sub?: Subscription;
  private rsub?: Subscription;
  constructor(private eszkoz: EszkozService, private toast: ToastController, private alert: AlertController,
              private route: ActivatedRoute, private router: Router, private naplo: NaploService, private keret: KeretService,
              private szerkZar: SzerkZarService) {}

  get aktiv() { return this.eszkoz.aktiv; }
  private get u() { return this.aktiv.ugyfelId; }
  private api(p: string) { return `/api/eszkoz${p}`; }

  async ngOnInit() {
    await this.eszkoz.init();
    //  A fül az útvonalból jön (/eszkoz/eszkozok, /eszkoz/ecs) – így a menüből és a jogkörből is külön kezelhető.
    this.rsub = this.route.data.subscribe((d) => { this.ful = d?.['ful'] === 'ecs' ? 'ecs' : 'lista'; if (this.ful === 'ecs') this.ecsBetolt(); });
    try {
      const cs: any = await this.eszkoz.getAbs(this.api('/csoportok'));
      this.csoportok = cs.csoportok || []; this.kivezetesJogcimek = cs.kivezetes || [];
    } catch { /* a lista enélkül is megy */ }
    //  Ügyfél- vagy évváltáskor újratöltünk.
    this.sub = this.eszkoz.aktiv$.subscribe(() => this.frissit());
    //  `?eszkoz=<id>`: a Könyvelés Naplók → Befektetett eszközök füléről érkezve az eszköz nyíljon meg.
    this.qsub = this.route.queryParamMap.subscribe((q) => { this.nyitandoId = q.get('eszkoz'); this.nyitandoNyit(); });
  }
  private qsub?: Subscription;
  private nyitandoId: string | null = null;
  private nyitandoNyit() {
    const e = this.nyitandoId && this.eszkozok.find((x) => x.id === this.nyitandoId);
    if (!e) return;
    this.nyitandoId = null;
    this.router.navigate([], { relativeTo: this.route, queryParams: { eszkoz: null }, queryParamsHandling: 'merge', replaceUrl: true });
    this.nyit(e);
  }
  ngOnDestroy() { this.vege = true; this.sub?.unsubscribe(); this.rsub?.unsubscribe(); this.qsub?.unsubscribe(); this.zarElenged(); }

  async frissit() {
    if (!this.u) return;
    this.betolt = true;
    try {
      try {
        const be: any = await this.eszkoz.getAbs(this.api(`/beallitas/${this.u}`));
        this.kisErtekuHatar = Number(be?.kis_erteku_hatar) || 200000; this.kettos = be?.konyveles_mod === 'kettos';
        this.rend = be || this.rend;
        await this.torzsBetolt();
      } catch { /* alapérték */ }
      //  A megnyitandó eszköz kivezetett is lehet – akkor azokat is betöltjük.
      const kiv = this.kivezetettek || !!this.nyitandoId;
      const r: any = await this.eszkoz.getAbs(this.api(`/eszkozok/${this.u}?ev=${this.aktiv.ev}&kivezetettek=${kiv ? 1 : 0}`));
      this.eszkozok = r.eszkozok || []; this.osszesen = r.osszesen || {};
      if (this.nyitandoId) { if (!this.kivezetettek) this.eszkozok = this.eszkozok.filter((x) => !x.kivezetes_datum || x.id === this.nyitandoId); this.nyitandoNyit(); }
      if (this.ful === 'ecs') await this.ecsBetolt();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült betölteni az eszközöket.'); }
    finally { this.betolt = false; }
  }
  fulValt(f: 'lista' | 'ecs') { this.router.navigate([f === 'ecs' ? '/eszkoz/ecs' : '/eszkoz/eszkozok']); }

  get lathato(): any[] {
    const k = this.kereso.trim().toLowerCase();
    return k ? this.eszkozok.filter((e) => String(e.megnevezes || '').toLowerCase().includes(k) || String(e.leltari_szam || '').toLowerCase().includes(k)) : this.eszkozok;
  }
  allapot(e: any): string { return e.kivezetes_datum ? 'kivezetve' : e.beruhazas ? 'beruházás' : e.penzugyi ? 'aktív' : (e.leirt ? 'leírva' : (e.ecs_mod === 'nincs' ? 'nem écs.' : 'aktív')); }
  /*  BEFEKTETETT PÉNZÜGYI ESZKÖZ (részesedés, értékpapír, tartósan adott kölcsön): nincs écs; az
   *  értékvesztést, a visszaírását és a törlesztést mozgásként rögzítjük (backend: /mozgas). */
  penzugyiCsoport(k: string): boolean { return !!this.csoportok.find((c) => c.kulcs === k)?.penzugyi; }
  get szerkPenzugyi(): boolean { return !!this.szerk && this.penzugyiCsoport(this.szerk.csoport); }
  d(v: any): string { return v ? String(v).slice(0, 10) : ''; }

  /* ── szerkesztés ── */
  uj() {
    this.zarElenged();
    const cs = this.csoportok.find((c) => c.kulcs === 'gep') || this.csoportok[0] || { kulcs: 'gep', tao: 14.5, szamlak: { brutto: '131', ecs: '139' } };
    const ma = `${this.aktiv.ev}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`;
    this.szerk = { id: null, megnevezes: '', leltari_szam: '', csoport: cs.kulcs, fokonyvi_szamla: cs.szamlak.brutto, ecs_szamla: cs.szamlak.ecs,
      ecs_koltseg_szamla: '', beszerzes_datum: ma, aktivalas_datum: ma, brutto_ertek: null, maradvany_ertek: 0,
      ecs_mod: 'linearis', ecs_kulcs: this.alapKulcs(cs), tao_kulcs: '', munkaszam: '', megjegyzes: '', partner_id: null, partner_nev: '', szamlaszam: '' };
    this.karton = null;
  }
  async nyit(e: any) {
    this.szerk = { ...e, beszerzes_datum: this.d(e.beszerzes_datum), aktivalas_datum: this.d(e.aktivalas_datum),
      brutto_ertek: Number(e.brutto_ertek), maradvany_ertek: Number(e.maradvany_ertek), ecs_kulcs: Number(e.ecs_kulcs),
      tao_kulcs: e.tao_kulcs == null ? '' : Number(e.tao_kulcs) };
    this.karton = null; this.aktivalas = null;
    //  Ugyanannak az eszköznek az újranyitása (mozgás után, újratöltés) a meglévő zárral megy tovább.
    if (!(this.zar && !this.zar.lezart && this.zar.rekord === String(e.id))) this.zarFoglal(String(e.id));
    try { this.karton = await this.eszkoz.getAbs(this.api(`/eszkoz/${e.id}/karton`)); } catch { /* karton nélkül is szerkeszthető */ }
  }
  /*  SZERKESZTÉSI ZÁR (components/szerk-zar): a mentés, a törlés, az aktiválás és a kivezetés a kiszolgálón
   *  is zárhoz kötött. A késve megjött zárat (közben bezárták, másikat nyitottak) rögtön elengedjük. */
  private async zarFoglal(id: string) {
    this.zarElenged();
    if (this.vege) return;
    const kor = this.zarKor;
    const z = await this.szerkZar.foglal('eszkoz', 'kettos_eszkoz', id, {
      ujratolt: () => (String(this.szerk?.id) === id ? this.kartonUjra() : undefined),
    });
    if (kor !== this.zarKor || this.vege || String(this.szerk?.id) !== id) { z?.felenged(); return; }
    this.zar = z;
  }
  zarElenged() { this.zarKor++; this.zar?.felenged(); this.zar = null; }
  bezar() { this.szerk = null; this.zarElenged(); }
  get zarTilt(): boolean { return !!this.zar && !this.zar.irhato; }
  //  Csoportváltás: a számlák és a Tao szerinti kulcs a csoport ajánlása (a kézzel átírtat is felülírja – a csoport dönt).
  csoportValt() {
    const cs = this.csoportok.find((c) => c.kulcs === this.szerk.csoport);
    if (!cs) return;
    this.szerk.fokonyvi_szamla = cs.szamlak.brutto; this.szerk.ecs_szamla = cs.szamlak.ecs;
    if (cs.penzugyi) { this.szerk.ecs_mod = 'nincs'; this.szerk.ecs_kulcs = 0; this.szerk.tao_kulcs = ''; this.szerk.maradvany_ertek = 0; return; }
    if (this.szerk.ecs_mod === 'nincs' && Number(this.szerk.ecs_kulcs) === 0) this.szerk.ecs_mod = 'linearis';
    if (this.szerk.ecs_mod === 'linearis') this.szerk.ecs_kulcs = this.alapKulcs(cs);
  }
  //  Egyéni vállalkozónál az Szja tv. 11. sz. melléklet kulcsa, egyébként a Tao szerinti ajánlás.
  alapKulcs(cs: any): number { return this.evRend && cs?.szja != null ? cs.szja : cs?.tao; }
  csoportKulcs(c: any): string { const k = this.evRend ? c.szja : c.tao; return k == null ? 'évekre felosztva' : `${k}%`; }
  csoportForras(): string { const c = this.csoportok.find((x) => x.kulcs === this.szerk?.csoport); return (this.evRend ? c?.szja_forras : c?.forras) || ''; }
  /*  Kis értékű eszköz: kettős könyvvitelnél az Szt. 80. § (2) szerinti „200 000 Ft alatt", egyéni
   *  vállalkozónál az Szja tv. 11. sz. mell. I. 2. szerinti „200 000 Ft-ot nem haladja meg". */
  get kisErtekuJavaslat(): boolean {
    const b = Number(this.szerk?.brutto_ertek) || 0;
    return !!this.szerk && b > 0 && (this.evRend ? b <= 200000 : b < this.kisErtekuHatar) && this.szerk.ecs_mod === 'linearis';
  }
  //  A 33%-os normájú eszköznél (SZJA) választható a két év alatti 50-50% (II. 2. g)).
  get ketevJavaslat(): boolean { return this.evRend && !!this.szerk && this.szerk.ecs_mod === 'linearis' && Number(this.szerk.ecs_kulcs) === 33; }
  modNev(m: string): string { return m === 'azonnali' ? 'egy ö.' : m === 'ketev' ? '50-50' : m === 'nincs' ? '–' : ''; }
  get evesEcs(): number { return Math.round((Number(this.szerk?.brutto_ertek) || 0) * (Number(this.szerk?.ecs_kulcs) || 0) / 100); }
  async ment() {
    const s = this.szerk;
    if (!String(s.megnevezes || '').trim()) return this.hiba('A megnevezés kötelező.');
    if (!(Number(s.brutto_ertek) > 0)) return this.hiba('Add meg a bruttó (bekerülési) értéket.');
    if (this.szerkPenzugyi && !s.aktivalas_datum) s.aktivalas_datum = s.beszerzes_datum;   // nincs használatbavétel – a szerzés napja
    if (!s.aktivalas_datum) return this.hiba('Az aktiválás (használatbavétel) dátuma kell – innen számol az écs.');
    if (this.zarTilt) return;
    try {
      await this.eszkoz.postAbs(this.api(`/eszkoz/${this.u}`), s);
      this.ok('Eszköz mentve.'); this.bezar(); await this.frissit();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }
  async torol() {
    if (this.zarTilt) return;
    const s = this.szerk;
    const a = await this.alert.create({ header: 'Eszköz törlése', message: `Törlöd: ${s.megnevezes}? (Ha már van elszámolt écs-e, törlés helyett ki kell vezetni.)`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Törlés', role: 'destructive', handler: async () => {
        try { await this.eszkoz.delAbs(this.api(`/eszkoz/${s.id}`)); this.bezar(); await this.frissit(); this.ok('Törölve.'); }
        catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült törölni.'); }
      } }] });
    a.present();
  }
  /*  IMPORT AZ RLB „eszközök" EXPORTJÁBÓL – előnézet, majd a kiválasztott sorok felvétele. A korábbi
   *  évek halmozott écs-e átvett nyitó sorként jön; a tárgyévi beszerzéseket alapból kihagyjuk (azokat
   *  a szállítói számlából kell könyvelni). */
  importAdat: any = null;
  private importFajl: File | null = null;
  importFajlValaszt(ev: Event) {
    const f = (ev.target as HTMLInputElement).files?.[0];
    (ev.target as HTMLInputElement).value = '';
    if (!f) return;
    this.importFajl = f;
    this.importElonezet();
  }
  private importKuld(extra: Record<string, string>) {
    const fd = new FormData();
    fd.append('file', this.importFajl as File);
    for (const [k, v] of Object.entries(extra)) fd.append(k, v);
    return this.eszkoz.postAbs(this.api(`/import-rlb/${this.u}?ev=${this.aktiv.ev}`), fd);
  }
  async importElonezet() {
    try {
      const r: any = await this.importKuld({ elonezet: '1' });
      this.importAdat = { ...r, sorok: (r.sorok || []).map((x: any) => ({ ...x, jelol: !!x.alap })) };
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült beolvasni a fájlt.'); }
  }
  get importJeloltDb(): number { return (this.importAdat?.sorok || []).filter((x: any) => x.jelol).length; }
  async importMent() {
    const leltari = (this.importAdat?.sorok || []).filter((x: any) => x.jelol).map((x: any) => x.leltari_szam);
    if (!leltari.length) return this.hiba('Nincs kiválasztott eszköz.');
    try {
      const r: any = await this.importKuld({ leltari: JSON.stringify(leltari) });
      this.importAdat = null; this.importFajl = null; await this.frissit();
      this.ok(`${r.felveve} eszköz importálva${r.frissitve ? `, ${r.frissitve} frissítve` : ''} – a ${r.ev - 1}. év végéig elszámolt écs átvett nyitóként.`);
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült az import.'); }
  }
  importAllapot(x: any): string { return x.allapot === 'uj' ? (x.kivezetes_datum ? 'kivezetett' : 'új') : x.allapot === 'frissites' ? 'frissítés' : x.allapot === 'mar_van' ? 'már szerepel' : x.allapot === 'targyevi' ? 'tárgyévi' : 'hibás'; }

  /*  AKTIVÁLÁS – a beruházásként (161) felvett eszköz üzembe helyezése: innen jár écs, kettős
   *  könyvvitelnél vegyes bizonylat T <eszköz főkönyvi száma> / K <beruházás számlája>. */
  aktivalas: any = null;
  aktivalasNyit() { this.aktivalas = { datum: `${this.aktiv.ev}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`, konyvel: this.kettos }; }
  async aktivalasMent() {
    if (this.zarTilt) return;
    try {
      const r: any = await this.eszkoz.postAbs(this.api(`/eszkoz/${this.szerk.id}/aktivalas`), this.aktivalas);
      this.aktivalas = null; this.bezar(); await this.frissit();
      this.ok(r?.tetel_id ? 'Aktiválva és lekönyvelve (vegyes napló).' : 'Aktiválva – innen számol az értékcsökkenés.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült aktiválni.'); }
  }
  async aktivalasVisszavon() {
    if (this.zarTilt) return;
    try { await this.eszkoz.postAbs(this.api(`/eszkoz/${this.szerk.id}/aktivalas-visszavon`), {}); this.bezar(); await this.frissit(); this.ok('Az aktiválás visszavonva – az eszköz újra beruházás.'); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült visszavonni.'); }
  }
  kivezetesNyit() { this.kivezetes = { datum: `${this.aktiv.ev}-12-31`, jogcim: 'ertekesites', megjegyzes: '', konyvel: !!this.rend?.konyvel && (this.kettos || !this.szerkPenzugyi), ellen_szamla: '' }; }
  kivezetesSzamla(): string {
    const j = this.kivezetesJogcimek.find((x) => x.kulcs === this.kivezetes?.jogcim);
    return (this.szerkPenzugyi ? j?.szamla_penzugyi : j?.szamla) || '';
  }
  //  A jogcímek az eszköz fajtája szerint: pénzügyi eszközt nem selejtezünk, tárgyi eszközt nem váltunk be.
  get kivezetesJogcimLista(): any[] {
    return this.kivezetesJogcimek.filter((j) => (this.szerkPenzugyi ? j.kulcs !== 'selejtezes' : !j.penzugyi));
  }
  /* ── mozgás (pénzügyi eszköz: értékvesztés, visszaírás, törlesztés, állománynövelés) ── */
  mozgas: any = null;
  mozgasNev(t: string): string {
    return ({ ertekno: this.szerkPenzugyi ? 'Állománynövelés' : 'Értéknövelés', terven_feluli: 'Terven felüli écs', visszairas: this.szerkPenzugyi ? 'Értékvesztés visszaírása' : 'Visszaírás',
      atsorolas: 'Átsorolás', ertekvesztes: 'Értékvesztés', torlesztes: 'Törlesztés' } as any)[t] || t;
  }
  mozgasNyit() {
    this.mozgas = { tipus: 'ertekvesztes', datum: `${this.aktiv.ev}-12-31`, osszeg: null, megjegyzes: '', konyvel: this.kettos, ellen_szamla: '' };
  }
  get mozgasKonyvelheto(): boolean { return this.kettos && ['ertekvesztes', 'visszairas'].includes(this.mozgas?.tipus); }
  mozgasEllen(): string {
    const cs = this.csoportok.find((c) => c.kulcs === this.szerk?.csoport);
    return (this.mozgas?.tipus === 'ertekvesztes' ? cs?.szamlak?.ertekvesztes : cs?.szamlak?.visszairas) || '874';
  }
  async mozgasMent() {
    const m = this.mozgas;
    if (!(Number(m.osszeg) > 0)) return this.hiba('Add meg az összeget.');
    try {
      const r: any = await this.eszkoz.postAbs(this.api(`/mozgas/${this.u}`), { ...m, eszkoz_id: this.szerk.id, konyvel: this.mozgasKonyvelheto && m.konyvel });
      this.mozgas = null;
      this.ok(r?.tetel_id ? `${this.mozgasNev(m.tipus)} rögzítve és lekönyvelve (vegyes napló).` : `${this.mozgasNev(m.tipus)} rögzítve.`);
      await this.kartonUjra();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült rögzíteni.'); }
  }
  async mozgasTorol(m: any) {
    const a = await this.alert.create({ header: 'Mozgás törlése',
      message: `Törlöd: ${this.mozgasNev(m.tipus)} ${this.szam(m.osszeg)} Ft (${m.datum})?${Number(m.konyvelt) ? ' A könyvelt bizonylata is törlődik.' : ''}`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Törlés', role: 'destructive', handler: async () => {
        try { await this.eszkoz.delAbs(this.api(`/mozgas/${m.id}`)); this.ok('Törölve.'); await this.kartonUjra(); }
        catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült törölni.'); }
      } }] });
    a.present();
  }
  //  A mozgás után a lista (nettó érték) és a karton is frissül, az ablak nyitva marad.
  private async kartonUjra() {
    const id = this.szerk?.id;
    await this.frissit();
    const e = this.eszkozok.find((x) => x.id === id);
    if (e) await this.nyit(e);
  }
  async kivezetesMent() {
    if (this.zarTilt) return;
    try {
      const r: any = await this.eszkoz.postAbs(this.api(`/eszkoz/${this.szerk.id}/kivezetes`), this.kivezetes);
      this.kivezetes = null; this.bezar(); await this.frissit();
      this.ok(!r?.tetel_id ? 'Kivezetve – a dátumtól nincs több értékcsökkenés.'
        : r.hova === 'naplo'
          ? `Kivezetve, a naplófőkönyvben elszámolva: écs a kivezetésig ${this.szam(r.potolt_ecs)} Ft, le nem írt érték ${this.szam(r.netto_koltseg)} Ft.`
          : `Kivezetve és lekönyvelve: nettó érték ${this.szam(r.netto)} Ft${r.potolt_ecs ? `, a kivezetésig pótolt écs ${this.szam(r.potolt_ecs)} Ft` : ''}.`);
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült kivezetni.'); }
  }
  async kivezetesVisszavon() {
    if (this.zarTilt) return;
    try { await this.eszkoz.postAbs(this.api(`/eszkoz/${this.szerk.id}/kivezetes-visszavon`), {}); this.bezar(); await this.frissit(); this.ok('A kivezetés visszavonva.'); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült visszavonni.'); }
  }
  honapNev(h: number): string { return ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember', 'október', 'november', 'december'][h - 1] || ''; }

  /* ── értékcsökkenés havonta ── */
  async ecsBetolt() {
    if (!this.u) return;
    try { this.ecs = await this.eszkoz.getAbs(this.api(`/ecs/${this.u}?ev=${this.aktiv.ev}&${this.idoszakQuery()}`)); }
    catch (e: any) { this.ecs = null; this.hiba(e?.error?.error || 'Nem sikerült kiszámolni.'); }
  }
  get ecsSorok(): any[] { return (this.ecs?.sorok || []).filter((x: any) => x.ecs || x.tao_ecs || x.mar_elszamolva || !x.ok || x.korabbi_hianyzik); }
  get ecsVanUj(): boolean { return (this.ecs?.sorok || []).some((x: any) => !x.mar_elszamolva && (x.ecs > 0 || x.tao_ecs > 0)); }
  get ecsVanFeladott(): boolean { return (this.ecs?.sorok || []).some((x: any) => x.mar_elszamolva); }
  get ecsHianyzik(): boolean { return (this.ecs?.sorok || []).some((x: any) => x.korabbi_hianyzik && !x.mar_elszamolva); }
  async feladas() {
    if (this.ecsHianyzik) {
      const a = await this.alert.create({ header: 'Kimaradt korábbi hónap',
        message: 'Van olyan eszköz, amelynek az előző havi écs-e nincs feladva. A havi écs sorban épül – előbb a korábbi hónapot érdemes feladni. Mégis feladod ezt a hónapot?',
        buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Feladás', handler: () => { this.feladasVegre(); } }] });
      await a.present(); return;
    }
    await this.feladasVegre();
  }
  private async feladasVegre() {
    this.feladasFut = true;
    try {
      const r: any = await this.eszkoz.postAbs(this.api(`/ecs/${this.u}/feladas`),
        this.negyedeves ? { ev: this.aktiv.ev, negyedev: this.negyedev } : { ev: this.aktiv.ev, ho: this.ho });
      const biz = r.bizonylatszam || '';
      this.ok(r.hova === 'fokonyv' ? `Feladva: ${r.eszkoz_db} eszköz, ${this.szam(r.osszeg)} Ft értékcsökkenés (vegyes napló, ${biz}).`
        : r.hova === 'naplo' ? `Feladva a naplófőkönyvbe: ${r.eszkoz_db} eszköz, ${this.szam(r.osszeg)} Ft (6. oszlop, pénzmozgás nélkül, ${biz}).`
        : r.elszamoltnak_tekintett ? `Nyilvántartásba véve: ${r.eszkoz_db} eszköz, ${this.szam(r.osszeg)} Ft – átalányadózásnál ez elszámoltnak tekintendő, költség nem lesz belőle.`
        : `Elszámolva a nyilvántartásban: ${r.eszkoz_db} eszköz, ${this.szam(r.osszeg)} Ft.`);
      await this.frissit();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült feladni.'); }
    finally { this.feladasFut = false; }
  }
  async visszavon() {
    const a = await this.alert.create({ header: 'Feladás visszavonása', message: `Visszavonod a(z) ${this.idoszakNev} értékcsökkenését? A feladott bizonylat is törlődik.`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Visszavonás', role: 'destructive', handler: async () => {
        try { await this.eszkoz.delAbs(this.api(`/ecs/${this.u}/feladas?ev=${this.aktiv.ev}&${this.idoszakQuery()}`)); await this.frissit(); this.ok('Visszavonva.'); }
        catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült visszavonni.'); }
      } }] });
    a.present();
  }

  szam(v: any): string { const n = Number(v); return isFinite(n) ? n.toLocaleString('hu-HU', { maximumFractionDigits: 0 }) : ''; }
  private async ok(m: string) { (await this.toast.create({ message: m, duration: 2600, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 3800, color: 'danger' })).present(); }
}
